module.exports = __webpack_public_path__ + "static/media/vivo-logo-essencial.81eb448f.svg";